import { createAction, props } from '@ngrx/store';
import { ResponseCreateUserAccount, RequestCreateUserAccount } from '../../shared/interfaces';
import { CreateUserAccountType } from '../../shared/enums';


export const getCreateUserAccount = createAction(
    CreateUserAccountType.CREATE_USER_ACCOUNT,
    props<{ request: RequestCreateUserAccount}>()
);

export const getCreateUserAccountSucess = createAction(
    CreateUserAccountType.CREATE_USER_ACCOUNT_SUCCESS,
    props<{ response: ResponseCreateUserAccount }>()
);

export const getCreateUserAccountError = createAction(
    CreateUserAccountType.CREATE_USER_ACCOUNT_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    CreateUserAccountType.CLEAN_STATE
);
